import { buildPageableParams } from '../common';
import { queryUntilLastPage } from '../common/pageable/query-until-last-page';
import { RevisionDto } from '../revision';
import { servicesApi } from '../services';
import { UtilisateurDto } from './types';

const utilisateurRevisionsApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({

    getAllUtilisateurRevisions: build.query<RevisionDto[], GetUtilisateurRevisionsQueryArgs, any>({
      queryFn: ({ id }, _api, _extraOptions, baseQuery) => queryUntilLastPage({
        baseQuery,
        url: `utilisateurs/${id}/revisions`,
        params: buildPageableParams({
          size: 30,
          sorters: [{ field: 'originalId.REV.id', direction: 'desc' }],
        }),
      }),
    }),

    getUtilisateurRevision: build.query<UtilisateurDto, GetUtilisateurRevisionQueryArgs, any>({
      query: ({ id, revisionId }) => ({
        url: `utilisateurs/${id}/revisions/${revisionId}/dto`,
      }),
    }),
  }),
});

interface GetUtilisateurRevisionsQueryArgs {
  id: number;
}

interface GetUtilisateurRevisionQueryArgs {
  id: number;
  revisionId: number;
}


export const {
  useGetAllUtilisateurRevisionsQuery,
  useGetUtilisateurRevisionQuery,
} = utilisateurRevisionsApi;